/* Cotton Culture V12: PDP cart-awareness.
   If the current product is already in the Shopify cart, turn the native and
   sticky PDP CTAs into "Go to cart" without adding a duplicate line item. */
(function () {
  'use strict';

  var initialized = false;
  var inCart = false;
  var productId = '';
  var scope = null;
  var realBtn = null;
  var stickyBtn = null;
  var productForm = null;
  var syncTimer = null;

  function cartUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart.js';
  }

  function openCart() {
    try {
      document.dispatchEvent(new CustomEvent('cart:open'));
    } catch (e) {
      window.location.href = '/cart';
    }
  }

  function keepButtonsUsable() {
    if (!inCart) return;
    if (realBtn && realBtn.disabled) realBtn.disabled = false;
    if (stickyBtn && stickyBtn.disabled) stickyBtn.disabled = false;
    if (realBtn) realBtn.setAttribute('aria-label', 'Go to cart');
    if (stickyBtn) stickyBtn.setAttribute('aria-label', 'Go to cart');
  }

  function applyState(nextState) {
    inCart = !!nextState;
    document.body.classList.toggle('cc-pdp-product-in-cart', inCart);
    if (scope) scope.classList.toggle('cc-product-in-cart', inCart);
    if (inCart) {
      keepButtonsUsable();
      window.requestAnimationFrame(keepButtonsUsable);
    } else {
      if (realBtn) realBtn.removeAttribute('aria-label');
      if (stickyBtn) stickyBtn.removeAttribute('aria-label');
    }
  }

  function syncFromCart() {
    if (!productId) return Promise.resolve();
    return fetch(cartUrl(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cart) {
        var exists = Array.isArray(cart.items) && cart.items.some(function (item) {
          return String(item.product_id) === String(productId);
        });
        applyState(exists);
      })
      .catch(function () {
        // Keep the normal Add to Cart behaviour if cart state cannot be read.
      });
  }

  function scheduleSync(delay) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncFromCart, delay || 80);
  }

  function isCurrentPdpButton(target) {
    if (!target || !target.closest) return false;
    var clicked = target.closest(
      '.product-section:not([data-modal="true"]) .product-single__form button[name="add"][data-add-to-cart], #cc-sticky-atc .cc-sticky-btn'
    );
    if (!clicked) return false;
    if (clicked.matches('#cc-sticky-atc .cc-sticky-btn')) return true;
    return !!(scope && scope.contains(clicked));
  }

  function init() {
    if (initialized) return;
    scope = document.querySelector('.product-section:not([data-modal="true"])[data-product-id]');
    if (!scope) return;

    productId = scope.getAttribute('data-product-id') || '';
    realBtn = scope.querySelector('.product-single__form button[name="add"][data-add-to-cart]');
    productForm = realBtn ? realBtn.closest('form') : null;
    stickyBtn = document.querySelector('#cc-sticky-atc .cc-sticky-btn');
    if (!productId || !realBtn) return;

    initialized = true;
    syncFromCart();

    // Capture before the theme's normal add-to-cart handler. If the product is
    // already in cart, open the drawer instead of adding another line item.
    document.addEventListener('click', function (event) {
      if (!inCart || !isCurrentPdpButton(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      openCart();
    }, true);

    if (productForm) {
      productForm.addEventListener('submit', function (event) {
        if (!inCart) return;
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        openCart();
      }, true);
    }

    // After this PDP adds successfully, mark it immediately and verify against
    // Shopify's cart after the drawer rebuild finishes.
    document.addEventListener('ajaxProduct:added', function (event) {
      var eventForm = event.target && event.target.closest ? event.target.closest('form') : null;
      if (eventForm && productForm && eventForm === productForm) {
        applyState(true);
      }
      scheduleSync(250);
    });

    // Quantity/removal changes from the native drawer can make the product no
    // longer present, so refresh state on the theme's cart lifecycle events.
    document.addEventListener('cart:updated', function () { scheduleSync(80); });
    document.addEventListener('cart:build', function () { scheduleSync(160); });
    window.addEventListener('pageshow', function () { scheduleSync(0); });

    // The theme can toggle disabled state after variant changes. Watch only the
    // two CTA buttons (not the page) so "Go to cart" remains clickable.
    var buttonObserver = new MutationObserver(function () {
      if (inCart) keepButtonsUsable();
    });
    buttonObserver.observe(realBtn, { attributes: true, attributeFilter: ['disabled'] });
    if (stickyBtn) buttonObserver.observe(stickyBtn, { attributes: true, attributeFilter: ['disabled'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
